<template>
  <div>
    <v-card >
      <v-card-title class="info-title" @click="$emit('clicked', index)">
        <font-awesome-icon class="collapse" :icon="getDetailIcon()"  />
        <div class="text-center text-padding">
          {{ item.Subject }}
        </div>
      </v-card-title>
      <div>
        <app-row
          icon="file-excel"
          title="شماره نامه: "
          :value="item.LetterID"
        />
        <app-row
          icon="question-circle"
          title="گيرنده: "
          :value="item.Girandeh"
        />
        <app-row
          icon="question-circle"
          title="تاریخ ارسال: "
          :value="item.DSend"
        />
        <div v-if="selectedMessage == index">
          <app-row icon="book" title="شماره درخواست:" :value="item.FSerial" />
          <app-row icon="book" title="متن پیام:" :value="item.Request" />
          <app-row icon="book" title="پاسخ:" :value="item.Response" />
          <app-row
            icon="download"
            title="دریافت پیوست:"
            :showButton="true"
            buttonText="دانلود"
            @clicked="$emit('download', item.FSerial)"
            v-if="item.HasAttachment == 1"
          />
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import DetailRow from "@/components/DetailRow";
export default {
  props: ["item", "index", "selectedMessage"],
  components: {
    appRow: DetailRow,
  },
  methods: {
    getDetailIcon() {
      return this.selectedMessage == this.index ? "angle-down" : "angle-left";
    },
  },
};
</script>
<style scoped>
.v-card__title {
  cursor: pointer;
}
</style>
